import { render, staticRenderFns } from "./Shopping.vue?vue&type=template&id=0a5a67b6&"
import script from "./Shopping.vue?vue&type=script&lang=js&"
export * from "./Shopping.vue?vue&type=script&lang=js&"
import style0 from "./Shopping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports